import { ServiceResponse } from '@nx-smartmonkey/shared/hooks';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { getRouteMutationKey } from '.';
import { routeService } from '../../../../application/RouteService';
import { Route } from '../../../../domain/route/Route';
import { RouteActionType } from '../context/actions';
import { useRouteContext } from '../context/context';

interface UseUpdateRouteStopsOrderProps {
  driverRoute: Route;
}

type UseUpdateRouteStopsOrderResponseProps = ServiceResponse<Function, void> & {
  reset: () => void;
};

// Hooks act as 'Adapter' layer.
export const useUpdateRouteStopsOrder = ({
  driverRoute,
}: UseUpdateRouteStopsOrderProps): UseUpdateRouteStopsOrderResponseProps => {
  const queryClient = useQueryClient();
  // const { execute } = useErrorMiddlewareNew();
  const { routeDispatch } = useRouteContext();
  // const { routesListDispatch } = useRoutesListContext();

  const { isLoading, isSuccess, isError, mutate, reset } = useMutation<
    Route,
    unknown,
    { stops: string[]; optimize: boolean }
  >(
    ({ stops, optimize }: { stops: string[]; optimize: boolean }): Promise<Route> => {
      return routeService.updateStopsOrder({
        stops: stops,
        optimize: optimize,
        route: driverRoute,
      });
    },
    {
      onSuccess: (updatedRoute) => {
        const key = getRouteMutationKey({ routeId: driverRoute.id });

        let previousQueryContent = queryClient.getQueryData<Route>(key);

        if (!previousQueryContent) {
          throw new Error(`previousQueryContent does not exist`);
        }

        previousQueryContent = updatedRoute;

        routeDispatch({ type: RouteActionType.FETCH_ROUTE_SUCCESS, payload: updatedRoute });
        queryClient.setQueryData<Route>(key, previousQueryContent);

        // Invalidates the search unfinished routes list
        // queryClient.invalidateQueries(getRouteMutationKey());
      },
    }
  );

  return {
    error: isError,
    success: isSuccess,
    isLoading: isLoading,
    run: ({ stops, optimize }: { stops: string[]; optimize: boolean }) => {
      mutate({ stops, optimize });
    },
    reset,
  };
};
